import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../models/user';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class UserDataService {

  constructor(private http: HttpClient) { }

  getAllUsers = (projectId: number) :  Observable<User[]> => {
    return this.http.get<User[]>(`${environment.api.baseUrl}/${environment.api.endpoints.user.userList}?projectId=${projectId}`);
  }

  resetUserPassword = (userId: number, projectId: number) => {
    return this.http.get(`${environment.api.baseUrl}/${environment.api.endpoints.user.resetPaswword}/${userId}?projectId=${projectId}`).toPromise();
  }

  getUser = (userId: number, projectId: number): Promise<User> => {
    return this.http.get<User>(`${environment.api.baseUrl}/${environment.api.endpoints.user.userList}/${userId}?projectId=${projectId}`).toPromise();
  }

  createUser = (user: User, projectId: number) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.user.createUser}?projectId=${projectId}`, {user} ).toPromise();
  }

  updateUser = (user: User, projectId: number) => {
    return this.http.post(`${environment.api.baseUrl}/${environment.api.endpoints.user.createUser}/${user.id}?projectId=${projectId}`, {user}).toPromise();
  }

  deleteUser = (userId: number, projectId: number) => {
    return this.http.delete(`${environment.api.baseUrl}/${environment.api.endpoints.user.userList}/${userId}?projectId=${projectId}`).toPromise();
  }
}
